<template>
    <el-dialog title="设备下拨" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
        <el-form :model="form">
            <el-form-item label="下拨给" :label-width="formLabelWidth">
                <el-select v-model="form.selectList" placeholder="请选择平台" clearable @change="handleSelectChange">
                    <el-option :label="item.nickname" :value="item.userId" v-for="item in  list"
                        :key="item.userId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="填写SN号" class="ml">
                <el-radio v-model="form.radio" :label="0">多个SN</el-radio>
                <el-radio v-model="form.radio" :label="1">SN号段</el-radio>
                <el-input type="textarea" :rows="2" placeholder="可输入多个sn，以英文逗号或换行分制" v-model="form.textarea"
                    v-if="form.radio == '0'">
                </el-input>
                <div v-else="form.radio == '1'">
                    <span>开始号段</span>
                    <el-input v-model="form.startNumber" controls-position="right" @change="updateRange" size="small"
                        style="width: 180px;">
                    </el-input>
                    <span>至</span>
                    <el-input v-model="form.endNumber" controls-position="right" @change="updateRange" size="small"
                        style="width: 180px;">
                    </el-input>
                    <span>结束号段</span>
                </div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="addVersions">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import equipmentApi from '@/api/equipment/messagecontrol.js'
export default {
    props: ['message', 'snNums'],
    data() {
        return {
            dialogFormVisible: false,
            form: {
                selectList: '', // 机构名称
                textarea: '', // SN号
                radio: 0, // 填写SN号的方式
                startNumber: '',
                endNumber: '',
            },
            formLabelWidth: '120px',
            /*是否打开图片选择*/
            isupload: true,
            imageUrl: '', // 上传图片
            result: '',
            list: [],
            userId: null,
            numbers: [],
            // snCodes: "",
        }
    },
    methods: {
        handleSelectChange(val) {
            // console.log(val);
            this.userId = val;
        },
        listFunc() {
            equipmentApi.getEquipmentSelectList({}).then(res => {
                // console.log(res);
                this.list = res.data;
            }).catch(err => {
                // console.log(err);
            })
        },
        // 关闭组件
        handleCancel() {
            this.dialogFormVisible = false // 关闭弹窗
            // 清空表单数据
            this.form.selectList = '';
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        pullDown(params) {
            // console.log('111', params);
            // 新增 请求
            equipmentApi.getEquipmentPullDown({ ...params }).then(response => {
                // console.log(response);
                this.$message({
                    message: '下拨成功',
                    type: 'success'
                });
                this.form.textarea = '',
                    this.form.startNumber = '',
                    this.form.endNumber = '',
                    this.dialogFormVisible = false
                this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
                this.$emit('add-success');
            }).catch(error => {
                // console.error(error);
            });
        },
        // 确定（新增）
        addVersions() {
            // console.log(this.form);
            if (this.form.selectList == "") {
                this.$message({
                    message: '请填写完整信息',
                    type: 'warning'
                });

            }
            // console.log(this.form)
            if (this.form.radio === 0) {
                const params = {
                    transferType: this.form.radio,
                    snCodes: this.form.textarea,
                    userId: this.userId,
                    originalUserId: this.userId
                }
                this.pullDown(params);
            } else if (this.form.radio === 1) {
                const params = {
                    transferType: this.form.radio,
                    startSnCode: this.form.startNumber,
                    endSnCode: this.form.endNumber,
                    userId: this.userId,
                    originalUserId: this.userId
                }
                this.pullDown(params);
            }
            if (this.form.radio == '2') {
                const params = {
                    snCodes: this.numbers.join(','),
                    userId: this.userId,
                    originalUserId: this.userId
                }
                // console.log(params)
                this.pullDown(params);
            }

        },
    },
    mounted() {
        this.listFunc();
    },
    watch: {
        message(newVal) {
            // console.log(newVal)
            this.dialogFormVisible = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        },
        snNums(newVal) {
            // console.log('组件接收的SN', newVal, typeof (newVal));
            this.form.textarea = newVal
        }
    },
}
</script>

<style scoped>
.ml {
    margin-left: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/equipment/messagecontrol/components/AddView.vue